import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { LoaderService } from "@shared/services/loader/loader.service";
import { ProgressSpinner } from "primeng/progressspinner";
import { AsyncPipe } from "@angular/common";

@Component({
    selector: "app-loader",
    templateUrl: "./loader.component.html",
    styleUrls: ["./loader.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ProgressSpinner, AsyncPipe],
})
export class LoaderComponent {
    loader = inject(LoaderService);
}
